import { FC, useRef, useState } from 'react';
import html2canvas from 'html2canvas';
import { Input } from './components/Input';
import { Button } from './components/Button';
import bg from "./bg.png";

export const App: FC<{}> = (props) =>
{
  const cardRef = useRef<HTMLDivElement>();
  const [ imageUrl, setImageUrl ] = useState<string>('');

  const [ name, setName ] = useState<string>('Xuxa Stokovisk H. Majestic');
  const [ passport, setPassport ] = useState<string>('665');
  const [ date, setDate ] = useState<string>(new Date().toLocaleDateString('pt-BR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }));

  const exportCard = () =>
  {
    if (!cardRef.current) return;

    html2canvas(cardRef.current, { useCORS: true, backgroundColor: null }).then(function (canvas) {
      var myImage = canvas.toDataURL("image/png");
      setImageUrl(myImage);
    });
  };

  return (
    <div className="flex flex-col gap-5 p-5">
      <div>
        <div className="grid grid-cols-3 gap-3 mb-4">
          <div>
            <div className="text-sm font-medium">Passaporte</div>
            <Input type="text"  value={ passport } onChange={ setPassport } />
          </div>
          <div>
            <div className="text-sm font-medium">Nome Completo</div>
            <Input type="text" value={ name } onChange={ setName } />
          </div>
          <div>
            <div className="text-sm font-medium">Data de Emissão</div>
            <Input type="text"  value={ date } onChange={ setDate } />
          </div>
        </div>
        <Button onClick={ exportCard }>Gerar Imagem</Button>
      </div>
      <div className="flex gap-3">
        <div>
          <div className="text-sm font-medium">Prévia:<span className="font-normal italic"> (desconsidere o deslocamento dos textos)</span></div>
          <div ref={ cardRef } className="w-[500px] h-[324px] flex flex-col overflow-hidden relative josefin-sans tracking-wider">
            <img src={bg} alt="a" className="absolute" />
            <div className="z-10">
              <div className="text-xl absolute top-[110px] left-[62px]">{name}</div>
              <div className="text-xl absolute top-[168px] left-[62px]">{passport}</div>
              <div className="text-3xl absolute top-[187px] left-[40px] ephesis-regular w-[300px] text-center whitespace-nowrap">{name}</div>
              <div className="text-sm absolute top-[225px] left-[350px]">{date}</div>
            </div>
          </div>
        </div>
        <div className="w-[500px]">
          <div className="text-sm font-medium">Resultado:</div>
          <img src={ imageUrl } alt="" />
        </div>
      </div>
    </div>
  )
};